module.exports = __webpack_public_path__ + "img/convenio-sesc.7778aacf.png";